import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from './user.service';

export const featurelockGuard: CanActivateFn = (route, state) => {
  // Inject UserService
  const userService = inject(UserService);

  const features = userService?.availableResources;
  const urlPath = state.url;

  if (urlPath.includes('/document') || urlPath.includes('/reduced-keyboard')) {
    console.log('--- Feature Lock Guard ---');
    console.log('URL do Estado:', urlPath);
    console.log('Recursos Disponíveis:', features);
    return features.includes('writer');
  }

  return true;
};
